import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { ApiError, GetTopicsParams, TopicsResponse } from 'types/models';
import { faksApiInstance as api } from './api';

export const useGetLabTopics = (
  params?: GetTopicsParams,
  options?: UseQueryOptions<TopicsResponse, AxiosError<ApiError>>
) =>
  useQuery({
    queryKey: ['topics', params],
    queryFn: () => api.get<TopicsResponse>('topics', { params }),
    ...options,
    enabled: !!params,
  });
